import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function IncludesSection() {
  const items = ['6 tomos completos de fundamentos a cerámicos', 'Protocolos paso a paso para cada servicio', 'Técnicas de lavado, pulido y protección', 'Química aplicada y diluciones correctas', 'Sistema para conseguir clientes y llenar la agenda', 'El servicio de mayor ticket del mercado', 'Todo organizado para ejecutar rápido, cobrar bien y fidelizar de por vida.'];
  return <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-136">
      <div className="max-w-3xl mx-auto" data-id="element-137">
        <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-10" data-id="element-138">
          📘 ¿Qué incluye exactamente
          <br data-id="element-139" /> el MegaPack Detailer Argentino?
        </h2>

        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-gray-100 mb-10" data-id="element-140">
          <ul className="space-y-5" data-id="element-141">
            {items.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-142">
                <CheckCircle2 className="w-7 h-7 text-green-500 flex-shrink-0 mt-0.5" data-id="element-143" />
                <span className="text-lg md:text-xl text-gray-800 font-medium" data-id="element-144">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        <CTAButton href="https://checkout.construyeprogreso.com/cart/48119785324714:1" text="👉 ACCEDER CON DESCUENTO" data-id="element-145" />
      </div>
    </section>;
}